import { DocsConfig } from "types";

export const docsConfig: DocsConfig = {
  mainNav: [
    {
      title: "Documentation",
      href: "/docs",
    },
    {
      title: "Guides",
      href: "/guides",
    },
  ],
  sidebarNav: [
    {
      title: "Overview",
      items: [
        {
          title: "API Overview",
          href: "/docs",
        },
      ],
    },
    {
      title: "Snapshots",
      items: [
        {
          title: "Create Snapshot",
          href: "/docs/snapshot/create",
          items: [
            {
              title: "Image Options",
              href: "/docs/snapshot/create/image-options",
            },
            {
              title: "PDF Options",
              href: "/docs/snapshot/create/pdf-options",
            },
            {
              title: "Block Options",
              href: "/docs/snapshot/create/block-options",
            },
            {
              title: "Credentials",
              href: "/docs/snapshot/create/credentials",
            },
            {
              title: "Metadata",
              href: "/docs/snapshot/create/metadata",
            },
          ],
        },
        {
          title: "Get Snapshot",
          href: "/docs/snapshot/status",
        },
        {
          title: "Delete Snapshot",
          href: "/docs/snapshot/delete",
        },
        {
          title: "Compare Snapshots",
          href: "/docs/snapshot/compare",
        },
      ],
    },
    {
      title: "Utilities",
      items: [
        {
          title: "Key Pages from Sitemap",
          href: "/docs/key-pages-from-sitemap",
        },
      ],
    },
  ],
};
